import React from 'react'
import '../../assets/styles/modal.css';
import { RxCrossCircled } from "react-icons/rx";

const Modal = ({ isOpen, onClose, title, children, showCloseButton = true, className = '' }) => {
  if (!isOpen) return null;

  return (
    <div className={`modal-overlay`} onClick={onClose}>
      <div 
        className={`modal ${className}`} 
        onClick={(e) => e.stopPropagation()}
      >
        {title && <h2 style={{textAlign:'center', color:"#5C308D", marginBottom:"20px", }}>{title}</h2>}
        <div className="modal-content">
          {children}
        </div>

        {showCloseButton && (
          <button className="edit-button" onClick={onClose}>
            <RxCrossCircled />
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;